import type { LeadPayload, QuizResult } from "@quiz/quiz-core";

export interface LeadResponse {
  ok: true;
  duplicate: boolean;
  event_id: string;
  authoritative_result: QuizResult;
  delivery_state: "pending" | "delivered" | "failed";
  delivery_states: Record<string, "pending" | "delivered" | "failed" | "suppressed">;
  mismatch: boolean;
}

export async function submitLead(payload: LeadPayload, fallbackError: string): Promise<LeadResponse> {
  let response: Response;
  try {
    response = await fetch("/api/lead", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload)
    });
  } catch {
    throw new Error(fallbackError);
  }
  let body: Partial<LeadResponse> & { ok?: boolean; error?: string; details?: string[] };
  try {
    body = await response.json();
  } catch {
    throw new Error(fallbackError);
  }
  if (!response.ok || !body.ok) {
    throw new Error(body.details?.join(", ") || body.error || fallbackError);
  }
  return body as LeadResponse;
}
